<script>
import form from '@/mixins/form'

export default {
  mixins: [form],
  props: {
    backend: {},
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    const info = await this.backend.info()
    this.fields = info.form.fields
  },
  data: () => ({
    fields: [],
    form: {}
  })
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar" />
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
